import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

export const selectReporting = createSelector(
  (state: RootState) => state,
  (state) => state.reporting
);

export const selectBulkReporting = createSelector(selectReporting, (state) => state.bulk);
export const selectReportingReports = createSelector(selectReporting, (state) => state.reports);
export const selectReportingBatch = createSelector(selectReporting, (state) => state.batch);
export const selectAfsls = createSelector(selectReporting, (state) => state.bulk.afsls);
